module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_7016.4a7d452f.png";